(function ($) {
    var _duration = 1000,
        _easing = "easeOutCubic",
        _width = window.innerWidth,
        _windowWidth = window.innerWidth,
        _windowHeight = window.innerHeight,
        _spmode = 768,
        _speed = 1000;
    _winScrollTop = 0;
    handleSYWMLogout();
    handleSortBox();
    headerSearchviewer('.container_header_search', '.container_header_search_box');
    headerSearch('.header_search', '.header_search_box');
    headerDropmenuviewer('a.dropmenu', '#dropmenu');
    spHamburgerMenu('.container_hamburger_menu', '#side_bar');
    dropdownMenu('.nav_item');
    preventEmptySearch();
    checkTltLength('h1.tlt_section span', 192, '14px');
    autoRemoveInlineStyles('#tt_popup');
    show404OnExactPath();
    togglePass();

    setTimeout(function () {
        $("form.singleProductPreOrderForm").each(function () {
            processPreOrderForm($(this));
        });
    }, 500);

    const observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            $(mutation.addedNodes).each(function () {
                var $node = $(this);
                if ($node.is('form.singleProductPreOrderForm') || $node.find('form.singleProductPreOrderForm').length) {
                    var $form = $node.is('form.singleProductPreOrderForm') ? $node : $node.find('form.singleProductPreOrderForm');
                    processPreOrderForm($form);
                }
            });
        });
    });
    observer.observe(document.body, { childList: true, subtree: true });

    $(document).on('click', '.btn-wishlist', function () {
        $("form.singleProductPreOrderForm").each(function () {
            processPreOrderForm($(this));
        });
    });

    window.addEventListener('load', function () {
        $("form.singleProductPreOrderForm").each(function () {
            processPreOrderForm($(this));
        });
        const checker = setInterval(function () {
            if ($('#cart-delivery-datetime_section_os2 #delivery-datetime--isRender').length) {
                $('#loading').hide();
                clearInterval(checker);
            }
        }, 100);
    });

    function handleSortBox() {
        if ($('.sort_box').length > 0) {
            const $sortTitles = $('.sort_box .sort_title');
            $sortTitles.on('click', function (e) {
                e.stopPropagation();
                const $sort_box = $(this).next('ul');
                $('.sort_box ul').not($sort_box).slideUp();
                $sort_box.slideToggle();
            });
            $(document).on('click', function (e) {
                if (!$(e.target).closest('.sort_box').length) {
                    $('.sort_box ul').slideUp();
                }
            });
        }
    }
})(jQuery);

function addToList(key, variantId) {
    var list = JSON.parse(localStorage.getItem(key)) || [];
    variantId = String(variantId);

    if (!list.includes(variantId)) {
        list.push(variantId);
        localStorage.setItem(key, JSON.stringify(list));
    }
}

function removeFromList(key, variantId) {
    var list = JSON.parse(localStorage.getItem(key)) || [];
    variantId = String(variantId);

    var newList = list.filter(function (id) {
        return id !== variantId;
    });
    localStorage.setItem(key, JSON.stringify(newList));
}

function processPreOrderForm($form) {

    var $button = $form.find('button.add_cart');
    var variantId =
        $form.find('input.product-variant-id').val() ||
        $button.data('variant-id');

    if (!variantId) return;

    var isPreOrder = $form.find('input[name="preorder_id"]').length > 0;
    var soldOutAttr = $button.attr('data-sold-out');
    var soldOut = soldOutAttr !== undefined ? parseInt(soldOutAttr, 10) : null;

    if (isPreOrder) {
        addToList('preOrderItems', variantId);
        removeFromList('soldOutItems', variantId);
        return;
    }

    if (!isPreOrder && soldOut === 0) {
        addToList('soldOutItems', variantId);
        removeFromList('preOrderItems', variantId);
        return;
    }

    removeFromList('preOrderItems', variantId);
    removeFromList('soldOutItems', variantId);
}

/*
     sphamburgerMenu
 */
function spHamburgerMenu(_elm, _navi) {
    if ($(_elm).length) {
        $(_elm).off('click');
        $(_elm).on('click', function () {
            $(_navi).toggleClass('active');
            $(this).toggleClass('active');
        });
    }
}
/*
    headerSearchviewer
*/
function headerSearchviewer(_elm, _box) {
    if ($(_elm).length) {
        $(_box).fadeOut();
        $(_elm).off('click');
        $(_elm).on('click', function () {
            $(_box).fadeIn();
            $('#header .pc ul.container_footer_sns_items').children().slice(0, 2).fadeOut();
        });
        $(_elm).off('mouseenter mouseleave');
        $(_elm).on({
            'mouseenter': function () {
                $(_box).fadeIn();
                $('#header .pc ul.container_footer_sns_items').children().slice(0, 2).fadeOut();
            },
            'mouseleave': function () {
            }
        });
        $(document).on('click', function (e) {
            // ２．クリックされた場所の判定
            if (!$(e.target).closest(_box).length && !$(e.target).closest('.container_header_search img').length && !$(e.target).closest('.container_header_search').length) {
                $(_box).fadeOut();
                $('#header .pc ul.container_footer_sns_items').children().slice(0, 2).fadeIn();
            } else if ($(e.target).closest('.container_header_search img').length) {
                // ３．ポップアップの表示状態の判定
                if ($(_box).is(':hidden')) {
                    $(_box).fadeIn();
                    $('#header .pc ul.container_footer_sns_items').children().slice(0, 2).fadeOut();
                } else {
                    $(_box).fadeOut();
                    $('#header .pc ul.container_footer_sns_items').children().slice(0, 2).fadeIn();
                }
            }
        });
    }
}

/*
    headerSearch
*/
function headerSearch(_elm, _box) {
    if ($(_elm).length) {
        $(_elm).off('click');
        $(_elm).on('click', function () {
            $(_box).fadeIn();
        });
        $(_elm).off('mouseenter mouseleave');
        $(_elm).on({
            'mouseenter': function () {
                $(_box).fadeIn();
            },
            'mouseleave': function () {
            }
        });
        $(document).on('click', function (e) {
            // ２．クリックされた場所の判定
            if (!$(e.target).closest(_box).length && !$(e.target).closest('.header_search img').length) {
                $(_box).fadeOut();
            } else if ($(e.target).closest('.header_search img').length) {
                // ３．ポップアップの表示状態の判定
                if ($(_box).is(':hidden')) {
                    $(_box).fadeIn();
                } else {
                    $(_box).fadeOut();
                }
            }
        });
    }
}

/*
    headerDropmenuviewer
*/
function headerDropmenuviewer(_elm, _box) {
    if ($(_elm).length) {
        $(_elm).off('click');
        $(_elm).on('click', function () {
            $(_box).fadeToggle();
            return false;
        });
        $(_elm).on({
            'mouseleave': function () {
                _delay = setTimeout(function () {
                    $(_box).fadeOut();
                    clearTimeout(_delay);
                }, 1000);
            }
        });
        $(_box).off('mouseenter mouseleave');
        $(_box).on({
            'mouseenter': function () {
                if (_width <= _spmode) {
                } else {
                    clearTimeout(_delay);
                    $(_box).show();
                }
            },
            'mouseleave': function () {
                if (_width <= _spmode) {
                } else {
                    if ($(this).is(':visible')) {
                        _delay = setTimeout(function () {
                            $(_box).fadeOut();
                            clearTimeout(_delay);
                        }, 1000);
                    }
                }
            }
        });
    }
}
function handleLanguageSelect() {
    $('.menu_item_btn').click(function () {
        $(this).siblings('.language_select').stop().slideToggle();
    });

    $('.language_select li a').click(function (e) {
        e.preventDefault();

        let selectedText = $(this).text();
        let menuItem = $(this).closest('.util_pc').find('.menu_item_btn');

        menuItem.text(selectedText);
        $(this).closest('.language_select').slideUp();
    });
}
function dropdownMenu(_elm) {
    $(_elm).on('click', function () {
        const $this = $(this);
        const isActive = $this.hasClass('active');

        $(_elm).removeClass('active');
        if (!isActive) $this.addClass('active');
    });
}

function preventEmptySearch() {
    const form = $('form[action="/search"]');
    if (!form.length) return;

    form.on('submit', function (e) {
        const value = $(this).find('input[name="q"]').val().trim();
        if (value === "") {
            e.preventDefault();
        }
    });
}

function checkTltLength(_elm, _limit, _size) {
    const isSP = window.matchMedia("(max-width: 767px)").matches;
    if (!isSP) return;

    $(_elm).each(function () {
        if ($(this).width() > _limit) {
            $(this).css('font-size', _size);
        }
    });
}
function autoRemoveInlineStyles(selector, exceptions = []) {
    const exceptionSelector = exceptions.join(',');

    const observer = new MutationObserver(() => {
        const el = $(selector);
        if (!el.length) return;

        el.find('*').addBack().each(function () {
            // Skip if element matches or is inside any excluded selector
            if (exceptionSelector && $(this).closest(exceptionSelector).length) return;
            $(this).removeAttr('style');
        });

        observer.disconnect();
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
}
function show404OnExactPath() {
    var path = window.location.pathname;
    var paths404 = ['/collections', '/collections/', '/products', '/products/'];

    if (paths404.includes(path)) {
        $('#collections-listing').append(`
          <section class="section" id="page_404">
            <div class="inner">
              <div class="error_content">
                <p class="error_message">お探しのページは見つかりませんでした</p>
                <a href="/" class="btn_home">トップへ戻る</a>
              </div>
            </div>
          </section>
        `);
    }
}
function handleSYWMLogout() {
    if (!shopifyCustomerLoggedIn) {
        const prefixes = ["swym", "customerAccessToken"];

        // --- Delete matching localStorage keys ---
        for (let i = localStorage.length - 1; i >= 0; i--) {
            const key = localStorage.key(i);
            if (prefixes.some(prefix => key.startsWith(prefix))) {
                localStorage.removeItem(key);
            }
        }

        // --- Delete matching cookies ---
        document.cookie.split(";").forEach(cookie => {
            const [rawName] = cookie.split("=");
            const name = rawName.trim();

            if (prefixes.some(prefix => name.startsWith(prefix))) {
                document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/;`;
            }
        });
        waitForSwym(() => {
            _swat.disconnectShopperContext(
                function () {
                    console.log('Swym Shopper Context disconnected on logout.');
                },
                function (error) {
                    console.error('Error disconnecting Swym Shopper Context:', error);
                }
            );
        })
    }
}
function slickSlider(_sliderElm, config) {
    $(_sliderElm).each(function () {
        let $this = $(this);
        let slideCount = $this.children().length;

        if (slideCount > 1) {
            $this.slick(config);
        }
    });
}
function togglePass() {
    const ICON_HIDE = "url('../assets/hide_pass.png')";
    const ICON_SHOW = "url('../assets/show_pass.png')";

    $('.show_hide').on('click', function (e) {
        const $container = $(this);
        const $input = $container.find('.input');
        const offset = $container.offset();
        const containerWidth = $container.outerWidth();
        const clickX = e.pageX - offset.left;

        if (clickX > (containerWidth - 55)) {
            e.preventDefault();
            e.stopPropagation();
            const isPassword = $input.attr('type') === 'password';
            this.style.setProperty('--pass-icon', isPassword ? ICON_SHOW : ICON_HIDE);

            $input.attr('type', isPassword ? 'text' : 'password');
            $input.focus();
        }
    });
}